import React, { useEffect, useState } from "react";
import "./Setting.scss";

import { MdLogout } from "react-icons/md";
import { IoIosArrowBack } from "react-icons/io";
import { MdAddBox } from "react-icons/md";
import { GoCopy } from "react-icons/go";

import SettingLists from "../../constants/settingLists";
import { Link } from "react-router-dom";

import ROUTES from "../../constants/routes";
import { useDispatch, useSelector } from "react-redux";
import { clearUser } from "../../redux/features/user-slice";
import { clearOrganization } from "../../redux/features/organization-slice";
import { clearBranches } from "../../redux/features/branch-slice";
import { clearCart } from "../../redux/features/cart-slice";
import { logoutUser } from "../../api/auth";

import { useViewPortDetector } from "../../helpers/viewPortDetector";

import GeneralSetting from "./General/General";
import DeliveryRates from "./Delivery/DeliveryRates";
import Activities from "./Activities/Activities";
import AddDelivery from "./Delivery/AddDelivery/AddDelivery";
import Currency from "./General/Currency/Currency";
import OrdersSales from "./OrdersSales/OrdersSales";
import { clearAnalytics } from "../../redux/features/analytics-slice";
import { clearHomeData } from "../../redux/features/home-slice";
import {
  clearSubscriptionPlans,
  updateOpenSubscriptionAd,
} from "../../redux/features/subscription-slice";
import { Capacitor } from "@capacitor/core";
import { toast } from "react-toastify";
import { Clipboard } from "@capacitor/clipboard";
import { PiListStarDuotone } from "react-icons/pi";
import { clearProducts } from "../../redux/features/products-slice";
import { storage } from "../../helpers/storage";
import { clearSales } from "../../redux/features/sales-slice";
import { clearOrders } from "../../redux/features/orders-slice";
import { clearCustomers } from "../../redux/features/customers-slice";
import useOrganizationIsAllowed from "../../helpers/organizationPrevillages";

const CATALOG_URL = process.env.REACT_APP_CATALOG_URL;

const Setting = () => {
  const { currentViewPort } = useViewPortDetector();
  const user = useSelector((state) => state.userReducer.value);
  const { uId: organizationUid } = useSelector(
    (state) => state.organizationReducer.value
  );
  const dispatch = useDispatch();

  const orgIsAllowedToAccessCatalog =
    useOrganizationIsAllowed("online_catalog");

  const handleLogOut = () => {
    logoutUser(user.token)
      .then((res) => {})
      .catch((err) => {});
    dispatch(clearUser());
    dispatch(clearProducts());
    dispatch(clearAnalytics());
    dispatch(clearBranches());
    dispatch(clearCart());
    dispatch(clearHomeData());
    dispatch(clearOrganization());
    dispatch(clearSubscriptionPlans());
    dispatch(clearSales());
    dispatch(clearOrders());
    dispatch(clearCustomers());
    storage.removeAll();
  };

  const [selectedTab, setSelectedTab] = useState("General");
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (selectedTab !== "Edit Delivery Rate" && selectedItem) {
      setSelectedItem(null);
    }
  }, [selectedTab]);

  const handleCopy = () => {
    if (orgIsAllowedToAccessCatalog.exists) {
      const textToCopy = `${CATALOG_URL}/catalog/${organizationUid}`;
      if (Capacitor.isNativePlatform()) {
        Clipboard.write({
          string: textToCopy,
        })
          .then(() => {
            toast.dismiss(); toast.info("Copied to clipboard!");
          })
          .catch((err) => {
            toast.dismiss(); toast.error("Failed to copy!");
          });
      } else {
        navigator.clipboard
          .writeText(textToCopy)
          .then(() => {
            toast.dismiss(); toast.info("Copied to clipboard!");
          })
          .catch((err) => {
            toast.dismiss(); toast.error("Failed to copy!");
          });
      }
    } else {
      dispatch(updateOpenSubscriptionAd({ openAd: true }));
    }
  };

  return (
    <>
      <div className="page-with-side-components">
        <div className="setting">
          <div className="desktop-navbar box-shadow">
            <p>{ROUTES.settings.title}</p>
          </div>
          <div className="setting-container container-wrapper">
            {SettingLists.map((setting, i) => {
              if (currentViewPort === "mobile") {
                return (
                  <Link to={setting.link} className="setting-item" key={i}>
                    {setting.icon} <p>{setting.name}</p>
                  </Link>
                );
              } else {
                return (
                  <div
                    onClick={() => {
                      setSelectedTab(setting.name);
                    }}
                    className="setting-item"
                    key={i}
                  >
                    {setting.icon} <p>{setting.name}</p>
                  </div>
                );
              }
            })}

            <div className="setting-item" onClick={handleCopy}>
              <GoCopy /> <p>Copy Catalog Link</p>
            </div>

            {orgIsAllowedToAccessCatalog.exists ? (
              <a
                className="setting-item"
                href={`${CATALOG_URL}/catalog/${organizationUid}`}
                target="_blank"
                rel="noreferrer"
              >
                <PiListStarDuotone /> <p>Open Catalog Link</p>
              </a>
            ) : (
              <div
                className="setting-item"
                onClick={() => {
                  dispatch(updateOpenSubscriptionAd({ openAd: true }));
                }}
              >
                <PiListStarDuotone /> <p>Open Catalog Link</p>
              </div>
            )}

            <Link
              onClick={handleLogOut}
              to={ROUTES.login.path}
              className="setting-item log-out"
            >
              <MdLogout /> <p>Log Out</p>
            </Link>
          </div>
        </div>
        <div className="right-desktop-view">
          <div className="desktop-navbar border-bottom box-shadow">
            {selectedTab !== "General" && (
              <div
                className="back"
                onClick={() => {
                  if (
                    selectedTab === "Add Delivery Rate" ||
                    selectedTab === "Edit Delivery Rate"
                  ) {
                    setSelectedTab("Delivery Rates");
                  } else {
                    setSelectedTab("General");
                  }
                }}
              >
                <IoIosArrowBack />
              </div>
            )}
            <p>{selectedTab}</p>
            {selectedTab === "Delivery Rates" && (
              <div className="last-tag-svg">
                <MdAddBox
                  onClick={() => {
                    setSelectedTab("Add Delivery Rate");
                  }}
                />
              </div>
            )}
          </div>

          {selectedTab === "General" && (
            <GeneralSetting
              desktopView={true}
              setSelectedTab={setSelectedTab}
            />
          )}

          {selectedTab === "Orders and Sales" && (
            <OrdersSales desktopView={true} setSelectedTab={setSelectedTab} />
          )}
          {selectedTab === "Delivery Rates" && (
            <DeliveryRates
              desktopView={true}
              setSelectedItem={setSelectedItem}
              setSelectedTab={setSelectedTab}
            />
          )}
          {selectedTab === "Account Activities" && <Activities />}
          {selectedTab === "Add Delivery Rate" && (
            <AddDelivery desktopView={true} setSelectedTab={setSelectedTab} />
          )}
          {selectedTab === "Edit Delivery Rate" && (
            <AddDelivery
              desktopView={true}
              isEdit={true}
              selected={selectedItem}
              setSelectedTab={setSelectedTab}
            />
          )}

          {selectedTab === "Change Currency" && <Currency />}
        </div>
      </div>
    </>
  );
};

export default Setting;
